/**
 * Component: Header navigation
 *
 * Dependencies:
 * - OwlCarousel 2.x.x
 */

var prongHorn = prongHorn || {};

prongHorn.slider = prongHorn.slider || function() {

    var leftSlideNav = '<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/Files/Templates/Designs/Pronghorn/dist/icons/icons.svg#arrow"></use></svg>';
    var rightSlideNav = '<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/Files/Templates/Designs/Pronghorn/dist/icons/icons.svg#arrow"></use></svg>';

    this.initProductSlider = function(selector) {
        var $selector = $(selector);

        $selector.owlCarousel({
            responsive:{
                0:{
                    items:1
                },
                480:{
                    items: 2
                },
                600:{
                    items: 3
                },
                900:{
                    items: 4
                }
            },
            items: 1,
            loop: true,
            margin: 30,
            autoplay: true
        });
    }

    this.initDefault = function(selector) {
        var $selector = $(selector);

        if($selector.length) {

            $selector.owlCarousel({
                responsive:{
                    0:{
                        items:1
                    }
                },
                navigation: true,
                loop: true,
                dotsClass: "slider-dots",
                dotClass: "slider-dots__items",
                autoplay: true
            });
            
        }

    };


    this.initImageSlider = function(selector) {
        var $selector = $(selector);

        $selector.owlCarousel({
            items: 1,
            margin: 30,
            loop: true,
            singleItem: true,
            thumbs: true,
            thumbsPrerendered: true,
            dotsClass: "slider-dots",
            dotClass: "slider-dots__items",
            nav: true,
            navText: [leftSlideNav, rightSlideNav],
            autoplay: false
        });

        initZoom($selector);
    }

    // Helper
    function initZoom($selector) {

        $selector.find('a').magnificPopup({
            type: 'image',
            gallery:{
                enabled:true
            }
        });
    }

    // Public functions
    return {
        initDefault: initDefault,
        initProductSlider: initProductSlider,
        initImageSlider: initImageSlider
    };

}();